"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CreateReviewTemplateRequest () {
        return CreateReviewTemplateRequest;
    },
    get GetReviewTemplatesQueryParams () {
        return GetReviewTemplatesQueryParams;
    },
    get UpdateReviewTemplateRequest () {
        return UpdateReviewTemplateRequest;
    }
});
const _zod = require("zod");
const _formassignment = require("../form-assignment");
const CreateReviewTemplateRequest = _zod.z.object({
    name: _zod.z.string().min(1, "Template name is required"),
    formAssignments: _zod.z.array(_formassignment.TemplateFormAssignmentInput).default([])
});
const UpdateReviewTemplateRequest = _zod.z.object({
    name: _zod.z.string().min(1, "Template name is required"),
    formAssignments: _zod.z.array(_formassignment.TemplateFormAssignmentInput).default([])
});
const GetReviewTemplatesQueryParams = _zod.z.object({
    search: _zod.z.string().optional(),
    sortBy: _zod.z.enum([
        "name",
        "lastOpened",
        "formAssignmentsCount"
    ]).default("name"),
    sortOrder: _zod.z.enum([
        "asc",
        "desc"
    ]).default("asc")
});
